"use strict";

var _interopRequireWildcard = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.object.keys");
var _slicedToArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
var _defineProperty2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _core = require("echarts/core");
var _renderers = require("echarts/renderers");
var _charts = require("echarts/charts");
var _components = require("echarts/components");
var _vueEcharts = _interopRequireWildcard(require("vue-echarts"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
var _shop = require("@/api/shop");
var _merchantSelect = _interopRequireDefault(require("@/components/merchant/merchantSelect.vue"));
var _deviceBattery = _interopRequireDefault(require("./components/charts/deviceBattery.vue"));
var _huandian = _interopRequireDefault(require("./components/charts/huandian.vue"));
var _store = _interopRequireDefault(require("@/store"));
// import name from 'module'
(0, _core.use)([_renderers.CanvasRenderer, _charts.PieChart, _components.TitleComponent, _components.TooltipComponent, _components.LegendComponent, _charts.BarChart, _components.DatasetComponent, _components.GridComponent]);
/**
*  统计 
    总用户数:
    租用中用户数:
    退电用户数:（归还）
    新增用户数:
    下单金额:
**/
//   当天金额，租用，归还
/**
 * 已有数据：
 *  今日新增用户
    今日新增用户下单数
    今日新增用户下单总额
 **/
var _default = {
  name: 'HelloWorld',
  components: {
    VChart: _vueEcharts.default,
    myDatePicker: _myDatePicker.default,
    DevicesChart: _deviceBattery.default,
    HuandianChart: _huandian.default,
    MerchantSelector: _merchantSelect.default
  },
  provide: function provide() {
    return (0, _defineProperty2.default)({}, _vueEcharts.THEME_KEY, this.themeMode);
  },
  // 粉色：租用待租用相加相加；
  // 成交金额当天的单独拿出；
  data: function data() {
    return {
      is_agent: false,
      LastFive: {
        value: 0
      },
      monthForm: {
        value: ''
      },
      config1: {
        number: [0],
        content: '用户总数:{nt}个',
        formatter: this.formatterConfig
      },
      config2: {
        number: [0],
        toFixed: 3,
        content: '收入总额{nt}元'
      },
      createTime: [],
      themeMode: 'light',
      isShow: false,
      searchForm: {
        createTime: '',
        merchant_id: ''
      },
      state: {
        totalNum: 110,
        unPayNum: 10,
        payNum: 20,
        refundNum: 10
      },
      option: {
        title: {
          text: '',
          left: 'center',
          top: 'center',
          textStyle: {
            rich: {
              value: {
                color: '#000',
                fontSize: 26,
                fontWeight: 'bold'
                // lineHeight: 20,
                // padding: [4, 0, 4, 0],
              },

              name: {
                color: '#000',
                lineHeight: 20
              }
            }
          }
        },
        label: {
          show: true,
          position: 'outside',
          //设置outside才会出现指示线
          fontSize: 14,
          color: this.fontColor,
          formatter: '{b}\n{c} 个'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [{
          name: '用户电池租用比例分布',
          type: 'pie',
          radius: ['40%', '70%'],
          data: [{}, {}],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }],
        color: this.fontColor
      },
      option5: {
        title: {
          text: "月度金额统计",
          left: "center",
          show: false
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}<br/>{a}: {c}元"
        },
        legend: {
          data: ["成交金额"],
          bottom: 10
        },
        xAxis: {
          type: "category",
          data: ["", "", "", "", ""],
          axisLabel: {
            interval: 0,
            fontWeight: 'bold',
            fontSize: 18,
            color: '#000'
          }
        },
        yAxis: {
          type: "value",
          name: "金额(元)",
          axisLabel: {
            formatter: "{value}元"
          }
        },
        series: [{
          name: '成交金额',
          type: "line",
          data: [0, 0, 0, 0, 0],
          smooth: false,
          itemStyle: {
            color: "#5470C6"
          },
          lineStyle: {
            width: 5 // 数值越大线条越粗
          },

          label: {
            show: true,
            fontWeight: 'bold',
            color: '#000',
            position: "top",
            formatter: "{c}元"
          }
        }]
      },
      // option5: {
      //     // title: {
      //     //     text: '当天租用情况与成交金额',
      //     //     left: 'left',
      //     // },
      //     label: {
      //         show: true,
      //         position: 'top', // 将标签显示在柱状图的顶部
      //         fontSize: 14,
      //         color: this.fontColor,
      //         formatter: (res) => {
      //             //   当天金额，租用，归还
      //             const unit = {
      //                 renting: '个',
      //                 back: '个',
      //                 totalAmount: '元',
      //             }
      //             const legendMap = {
      //                 renting: '新租用户',
      //                 back: '退电用户',
      //                 totalAmount: '付款金额',
      //             }
      //             const serName = res.seriesName
      //             let tooltipContent = ''
      //             // tooltipContent = `${res.name}<br/>`
      //             // 根据seriesIndex判断显示哪个字段，分别是0，1，2
      //             tooltipContent += `${legendMap[serName]} : ${res.data[serName]} ${unit[serName]}`
      //             return tooltipContent
      //         },
      //     },
      //     tooltip: {
      //         trigger: 'item',
      //         // formatter: '{a} <br/>{b} : {c} ({d}%)',
      //         formatter: (res) => {
      //             //   当天金额，租用，归还
      //             const legendMap = {
      //                 renting: '当天新租用户',
      //                 back: '当天退电用户',
      //                 totalAmount: '当天付款金额',
      //             }
      //             const serName = res.seriesName
      //             let tooltipContent = ''
      //             // tooltipContent = `${res.name}<br/>`
      //             // 根据seriesIndex判断显示哪个字段，分别是0，1，2
      //             tooltipContent += `${legendMap[serName]}: ${res.data[serName]}<br/>`
      //             return tooltipContent
      //         },
      //     },
      //     legend: {
      //         orient: 'horizontal',
      //         left: 'center',
      //         // data: ['vehi
      //         formatter: function(name) {
      //             const legendMap = {
      //                 renting: '当天新租用户',
      //                 back: '当天退电用户',
      //                 totalAmount: '当天付款金额',
      //             }
      //             return legendMap[name]
      //         },
      //     },
      //     dataset: {
      //         dimensions: ['name', 'renting', 'back', 'totalAmount'],
      //         source: [{ name: '新增用户/退电用户 下单金额统计', renting: 0, back: 0, totalAmount: 0 }],
      //     },
      //     xAxis: { type: 'category' },
      //     yAxis: [
      //         {
      //             type: 'value',
      //             name: '数量/单',
      //             // max: 10,
      //             nameTextStyle: {
      //                 fontSize: 14,
      //                 color: '#000',
      //             },
      //         }, // 第一个 y 轴用于显示数量次数
      //         {
      //             type: 'value',
      //             name: '价格/元',
      //             // max: 20000,
      //             nameTextStyle: {
      //                 fontSize: 14,
      //                 color: '#000',
      //             },
      //         }, // 第二个 y 轴用于显示价格元
      //     ],
      //     //中的yAxisIndex控制y轴对应关系
      //     series: [
      //         {
      //             type: 'bar',
      //             yAxisIndex: 0,
      //             itemStyle: {
      //                 borderRadius: [10, 10, 0, 0],
      //             },
      //         }, // 关联第一个 y 轴，用于绘制与数量次数相关的柱状图
      //         {
      //             type: 'bar',
      //             yAxisIndex: 0,
      //             itemStyle: {
      //                 borderRadius: [10, 10, 0, 0],
      //             },
      //         }, // 关联第二个 y 轴，用于绘制与价格元相关的柱状图
      //         {
      //             type: 'bar',
      //             yAxisIndex: 1,

      //             itemStyle: {
      //                 borderRadius: [10, 10, 0, 0],
      //             },
      //         }, // 这里再添加一个与数量次数相关的柱状图示例
      //     ],
      // },
      // 固定统计
      option6: {
        title: {
          text: '',
          left: 'center',
          top: 'center',
          textStyle: {
            rich: {
              value: {
                color: '#000',
                fontSize: 26,
                fontWeight: 'bold'
                // lineHeight: 20,
                // padding: [4, 0, 4, 0],
              },

              name: {
                color: '#000',
                lineHeight: 20
              }
            }
          }
        },
        // color: '#000',
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'left'
        },
        series: [(0, _defineProperty2.default)({
          name: '固定统计',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            position: 'outside',
            //设置outside才会出现指示线
            fontSize: 14,
            color: this.fontColor,
            formatter: '{b} {c}'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          //    显示指示线
          labelLine: {
            show: true
          },
          data: [{
            name: '待租用',
            value: 0
          }, {
            name: '租用中',
            value: 0
          }, {
            name: '冻结',
            value: 0
          }]
        }, "emphasis", {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        })]
      },
      option4: {
        title: {
          text: "月度金额统计",
          left: "center",
          show: false
        },
        // tooltip: {
        //   trigger: "axis",
        //   formatter: "{b}<br/>{a}: {c}元"
        // },
        // legend: {
        //   data: ["金额"],
        //   bottom: 10
        // },
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var lirun = params[1].marker.replace('#ffaa00;', '#FF0000');
            var lirun_str = '利润';
            var lirun_money = params[0].value - params[1].value;
            lirun_money = lirun_money.toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1');
            return "".concat(params[0].axisValue, "<br/>\n\t\t\t\t\t\t\t             ").concat(params[0].marker, " ").concat(params[0].seriesName, ": ").concat(params[0].value, "\u5143<br/>\n\t\t\t\t\t\t\t             ").concat(params[1].marker, " ").concat(params[1].seriesName, ": ").concat(params[1].value, "\u5143<br/>\n\t\t\t\t\t\t\t\t\t\t ").concat(lirun, " ").concat(lirun_str, ": ").concat(lirun_money, "\u5143");
          }
        },
        legend: {
          data: ["下单", "支出"],
          // 同步更新图例显示
          bottom: 10
        },
        xAxis: {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          axisLabel: {
            interval: 0,
            fontWeight: 'bold',
            fontSize: 18,
            color: '#000'
          }
        },
        yAxis: {
          type: "value",
          name: "金额(元)",
          axisLabel: {
            formatter: "{value}元"
          }
        },
        series: [{
          name: "下单",
          type: "line",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          smooth: false,
          itemStyle: {
            color: "#5470C6"
          },
          lineStyle: {
            width: 5 // 数值越大线条越粗
          },

          label: {
            show: true,
            fontWeight: 'bold',
            color: '#000',
            position: "top",
            formatter: "{c}元"
          }
        }, {
          name: "支出",
          type: "line",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          smooth: false,
          itemStyle: {
            color: "#ffaa00"
          },
          lineStyle: {
            width: 5 // 数值越大线条越粗
          },

          label: {
            show: true,
            fontWeight: 'bold',
            color: '#000',
            position: "top",
            formatter: "{c}元"
          }
        }
        //    {
        //      name: "利润",
        //      type: "line",
        //      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        //      smooth: false,
        //   showSymbol: false,
        //      itemStyle: {
        //        color: "#FF0000"
        //      },
        //  lineStyle: {
        //   width: 5  // 数值越大线条越粗
        // },
        //      label: {
        //        show: false,
        //        position: "top",
        //        formatter: "{c}元"
        //      }
        //    }
        ]
      },

      // option4: {
      //     title: {
      //         text: '租用情况与成交金额',
      //         left: 'left',
      //     },
      //     label: {
      //         show: true,
      //         position: 'top', // 将标签显示在柱状图的顶部
      //         fontSize: 14,
      //         color: this.fontColor,
      //         formatter: (res) => {
      //             //   当天金额，租用，归还
      //             const unit = {
      //                 renting: '个',
      //                 back: '个',
      //                 totalAmount: '元',
      //             }
      //             const legendMap = {
      //                 renting: '待租用、租用中、冻结',
      //                 back: '归还',
      //                 totalAmount: '下单金额',
      //             }
      //             const serName = res.seriesName
      //             let tooltipContent = ''
      //             // tooltipContent = `${res.name}<br/>`
      //             // 根据seriesIndex判断显示哪个字段，分别是0，1，2
      //             tooltipContent += `${legendMap[serName]} : ${res.data[serName]} ${unit[serName]}`
      //             return tooltipContent
      //         },
      //     },
      //     tooltip: {
      //         trigger: 'item',
      //         // formatter: '{a} <br/>{b} : {c} ({d}%)',
      //         formatter: (res) => {
      //             //   当天金额，租用，归还
      //             const legendMap = {
      //                 renting: '租用中数量',
      //                 back: '归还数量',
      //                 totalAmount: '下单金额',
      //             }
      //             const serName = res.seriesName
      //             let tooltipContent = ''
      //             // tooltipContent = `${res.name}<br/>`
      //             // 根据seriesIndex判断显示哪个字段，分别是0，1，2
      //             tooltipContent += `${legendMap[serName]}: ${res.data[serName]}<br/>`
      //             return tooltipContent
      //         },
      //     },
      //     legend: {
      //         orient: 'horizontal',
      //         left: 'center',
      //         // data: ['vehi
      //         formatter: function(name) {
      //             const legendMap = {
      //                 renting: '租用中数量',
      //                 back: '归还数量',
      //                 totalAmount: '下单金额',
      //             }
      //             return legendMap[name]
      //         },
      //     },
      //     dataset: {
      //         dimensions: ['name', 'renting', 'back', 'totalAmount'],
      //         source: [{ name: '租用/归还 下单金额统计', renting: 0, back: 0, totalAmount: 0 }],
      //     },
      //     xAxis: { type: 'category' },
      //     yAxis: [
      //         {
      //             type: 'value',
      //             name: '数量/单',
      //             // max: 10,
      //             nameTextStyle: {
      //                 fontSize: 14,
      //                 color: '#000',
      //             },
      //         }, // 第一个 y 轴用于显示数量次数
      //         {
      //             type: 'value',
      //             name: '价格/元',
      //             // max: 20000,
      //             nameTextStyle: {
      //                 fontSize: 14,
      //                 color: '#000',
      //             },
      //         }, // 第二个 y 轴用于显示价格元
      //     ],
      //     //中的yAxisIndex控制y轴对应关系
      //     series: [
      //         {
      //             type: 'bar',
      //             yAxisIndex: 0,
      //             itemStyle: {
      //                 borderRadius: [10, 10, 0, 0],
      //             },
      //         }, // 关联第一个 y 轴，用于绘制与数量次数相关的柱状图
      //         {
      //             type: 'bar',
      //             yAxisIndex: 0,
      //             itemStyle: {
      //                 borderRadius: [10, 10, 0, 0],
      //             },
      //         }, // 关联第二个 y 轴，用于绘制与价格元相关的柱状图
      //         {
      //             type: 'bar',
      //             yAxisIndex: 1,
      //             itemStyle: {
      //                 borderRadius: [10, 10, 0, 0],
      //             },
      //         }, // 这里再添加一个与数量次数相关的柱状图示例
      //     ],
      // },
      option2: {
        title: {
          text: '',
          left: 'center',
          top: 'center',
          textStyle: {
            rich: {
              value: {
                color: '#000',
                fontSize: 26,
                fontWeight: 'bold'
                // lineHeight: 20,
                // padding: [4, 0, 4, 0],
              },

              name: {
                color: '#000',
                lineHeight: 20
              }
            }
          }
        },
        // color: '#000',
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'left'
        },
        series: [(0, _defineProperty2.default)({
          name: '换电记录',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            position: 'outside',
            //设置outside才会出现指示线
            fontSize: 14,
            color: this.fontColor,
            formatter: '{b} {c}'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          //    显示指示线
          labelLine: {
            show: true
          },
          data: [{}, {}]
        }, "emphasis", {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        })]
      },
      option3: {
        title: {
          top: 'center',
          left: 'center',
          textStyle: {
            rich: {
              value: {
                color: this.fontColor,
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: 20,
                padding: [4, 0, 4, 0]
              },
              name: {
                color: this.fontColor,
                lineHeight: 20
              }
            }
          }
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,.6)',
          borderColor: 'rgba(147, 235, 248, .8)',
          textStyle: {
            color: '#FFF'
          }
        },
        series: [{
          name: ' 新增用户情况总览',
          type: 'pie',
          radius: ['40%', '70%'],
          // avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 6,
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 2
          },
          color: this.colors,
          label: {
            show: true,
            formatter: function formatter(params) {
              // 自定义formatter函数，这里使用模板字符串来组合内容
              return "{b|".concat(params.name, "}\n{c|").concat(params.value, "\u4E2A} {per|").concat(params.percent, "%}");
            },
            //   position: "outside",
            rich: {
              b: {
                color: '#fff',
                fontSize: 12,
                lineHeight: 26
              },
              c: {
                color: '#31ABE3',
                fontSize: 14
              },
              per: {
                color: '#31ABE3',
                fontSize: 14
              }
            }
          },
          emphasis: {
            show: false
          },
          legend: {
            show: false
          },
          tooltip: {
            show: true
          },
          labelLine: {
            show: true,
            length: 20,
            // 第一段线 长度
            length2: 36,
            // 第二段线 长度
            smooth: 0.2,
            lineStyle: {}
          },
          data: []
        }]
      },
      colors: ['#0BFC7F', '#A0A0A0', '#F48C02', '#F4023C'],
      fontColor: '#000',
      page: 1,
      pageSize: 10,
      totalNumuserInfo: {
        totalNum: 0
      }
    };
  },
  watch: {
    createTime: function createTime(val) {
      if (val) {
        this.searchForm.createTime = val.join('~');
      } else {
        this.searchForm.createTime = '';
      }
    }
  },
  mounted: function mounted() {
    var xxz_supplier_merchant_id = this.$func.getCookie('xxz_supplier_merchant_id');
    if (xxz_supplier_merchant_id == '') {
      this.is_agent = true;
    }
    var chart = this.$refs.chart;
    console.log('chart', chart);
    this.initCreateTime();
    this.init();
  },
  methods: {
    handleLastFive: function handleLastFive() {
      var _this = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (type == true) {
        this.LastFive.value = -1;
      }
      (0, _shop.getStatisticsByFive)({
        LastFive: this.LastFive.value + 1,
        merchant_id: this.searchForm.merchant_id
      }).then(function (res) {
        var data = {
          last: res
        };
        _this.handleOptions5(data);
        _this.LastFive.value = _this.LastFive.value + 1;
      });
    },
    handleMonth: function handleMonth() {
      var _this2 = this;
      var date = new Date(this.monthForm.value);
      console.log('handleMonth', date.getTime());
      (0, _shop.getStatisticsByMonth)({
        month: date.getTime()
      }).then(function (res) {
        console.log('res==', res);
        var rentAndAmountInfo = res.rentAndAmountInfo;
        if (rentAndAmountInfo) {
          _this2.handleOptions4(rentAndAmountInfo);
        }
      });
    },
    handleMerchantIdUpdate: function handleMerchantIdUpdate(merchantId) {
      this.searchForm.merchant_id = merchantId;
      console.log('this.searchForm', this.searchForm);
    },
    formatterConfig: function formatterConfig(number) {
      var numbers = number.toString().split('').reverse();
      var segs = [];
      while (numbers.length) {
        segs.push(numbers.splice(0, 3).join(''));
      }
      return segs.join(',').split('').reverse().join('');
    },
    echartsGraphic: function echartsGraphic(colors) {
      return new _core.graphic.LinearGradient(1, 0, 0, 0, [{
        offset: 0,
        color: colors[0]
      }, {
        offset: 1,
        color: colors[1]
      }]);
    },
    toggleTheme: function toggleTheme() {
      this.themeMode = this.themeMode === 'dark' ? 'light' : 'dark';
      this.fontColor = this.fontColor == '#000' ? '#fff' : '#000';
    },
    jumpRoute: function jumpRoute(val) {
      var routeMap = {
        vel: '/inOutBound/in',
        part: '/inOutBound/part'
      };
      console.log('routeMap', routeMap[val]);
      this.$router.push({
        path: routeMap[val],
        query: {}
      });
    },
    initCreateTime: function () {
      var _initCreateTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var today, year, month, day, startOfDay, endOfDay;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                today = new Date();
                year = today.getFullYear();
                month = today.getMonth() + 1;
                day = today.getDate();
                startOfDay = "".concat(year, "-").concat(month.toString().padStart(2, '0'), "-").concat(day.toString().padStart(2, '0'), " 00:00:00");
                endOfDay = "".concat(year, "-").concat(month.toString().padStart(2, '0'), "-").concat(day.toString().padStart(2, '0'), " 23:59:59");
                this.createTime = [startOfDay, endOfDay];
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function initCreateTime() {
        return _initCreateTime.apply(this, arguments);
      }
      return initCreateTime;
    }(),
    // 查询
    search: function search() {
      var _this3 = this;
      this.$nextTick(function () {
        _store.default.commit('setTriggerApiCall', !_this3.triggerApiCall);
        _this3.init();
      });
    },
    // 重置
    reset: function () {
      var _reset = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.initCreateTime();
              case 2:
                this.init();
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }(),
    init: function init() {
      this.isShow = false;
      var page = this.page;
      var pageSize = this.pageSize;
      // this.toggleTheme()
      this.isShow = true;

      // setup option3

      // 使用 Promise.all 发起并发请求
      this.handlePromise(page, pageSize);
    },
    handlePromise: function handlePromise(page, pageSize) {
      var _this4 = this;
      console.log('this.searchForm.createTime', this.searchForm.createTime);
      Promise.all([(0, _shop.iotUserStatistics)({
        createTime: this.searchForm.createTime,
        merchant_id: this.searchForm.merchant_id
      })]).then(function (_ref4) {
        var _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
          iotUserRes = _ref5[0];
        console.log('图标统计信息', iotUserRes);
        _this4.iotInfoData = iotUserRes;

        // 处理统计图表数据
        /** * * { "allUserNum": 24,
         * "swapInfo": { "renting": 0, "isOver": 0,
         * "totalCount": 0 }, "rentData": [],
         * "userNewInfo": { "todayUserNumber": 0, "todayNewUserOrderCount": 0, "todayAmount": 0, "allUserNum": 24 } } *  **/
        var allUserNum = iotUserRes.allUserNum,
          allOrderNum = iotUserRes.allOrderNum,
          rentData = iotUserRes.rentData,
          swapInfo = iotUserRes.swapInfo,
          userNewInfo = iotUserRes.userNewInfo,
          rentAndAmountInfo = iotUserRes.rentAndAmountInfo,
          chart1 = iotUserRes.chart1,
          chart2 = iotUserRes.chart2;
        console.log('所有用户 ', allUserNum);
        console.log('出租表状态分析 ', rentData);
        console.log('新增用户详情 ', userNewInfo);
        console.log('出租=换电情况分布', swapInfo);
        console.log('租用、归还和购买金额', rentAndAmountInfo);
        _this4.handleOptions(rentData, allOrderNum);
        _this4.handleOptions2(swapInfo);
        _this4.handleOptions4(rentAndAmountInfo);
        _this4.handleOptions3(userNewInfo, rentAndAmountInfo); //处理另一个图标
        _this4.handleOptions5(chart1);
        _this4.handleOptions6(chart2);
      }).catch(function (error) {
        console.error('Error fetching data:', error);
      }).finally(function () {
        _this4.isShow = true;
      });
    },
    handleOptions4: function handleOptions4(rentAndAmountInfo) {
      var month_timestamps = rentAndAmountInfo.month_timestamps;
      var allmoney = [];
      var expenses_money = [];
      // let profit = []
      Object.keys(month_timestamps).forEach(function (key) {
        allmoney.push(month_timestamps[key].allmoney);
        expenses_money.push(month_timestamps[key].expenses_money);
        // let profit_money = month_timestamps[key].allmoney-month_timestamps[key].expenses_money
        // profit.push(profit_money.toFixed(2))
      });

      this.option4.series[0].data = allmoney;
      this.option4.series[1].data = expenses_money;
      // this.option4.series[2].data = profit
      return;
      var renting = rentAndAmountInfo.renting,
        isOver = rentAndAmountInfo.isOver,
        totalAmount = rentAndAmountInfo.totalAmount;
      // this.option4.yAxis[0].max = isOver > renting ? isOver : renting
      this.option4.dataset.source[0].back = isOver;
      this.option4.dataset.source[0].renting = renting;
      this.option4.dataset.source[0].totalAmount = totalAmount;
    },
    handleOptions5: function handleOptions5(chart1) {
      var last = chart1.last;
      var data = [];
      var time = [];
      Object.keys(last).forEach(function (key) {
        data.unshift(last[key].todayTotalAmount);
        time.unshift(last[key].day);
      });
      this.option5.xAxis.data = time;
      this.option5.series[0].data = data;
      return;
      console.log('chart1:', chart1);
      var todayReturnUser = chart1.todayReturnUser,
        todayAddUser = chart1.todayAddUser,
        todayTotalAmount = chart1.todayTotalAmount;
      // this.option4.yAxis[0].max = isOver > renting ? isOver : renting
      this.option5.dataset.source[0].back = todayReturnUser;
      this.option5.dataset.source[0].renting = todayAddUser;
      this.option5.dataset.source[0].totalAmount = todayTotalAmount;
    },
    handleOptions: function handleOptions(data, allOrderNum) {
      var newTitle = ["{value|".concat(allOrderNum, "}"), '{name|下单成功总数}'].join('\n');
      this.option.title.text = newTitle;
      this.option.series[0].data = data;
    },
    // 处理option2内容
    handleOptions2: function handleOptions2(swapInfo) {
      console.log('换电情况以及换电出租总数', swapInfo);
      this.option2.series[0].data = swapInfo.data;
      var newTitle = ["{value|".concat(swapInfo.totalCount, "}"), '{name|租用/归还 统计}'].join('\n');
      this.option2.title.text = newTitle;
    },
    handleOptions6: function handleOptions6(chart2) {
      console.log('chart2', chart2);
      this.option6.series[0].data = chart2;
      var allNum = chart2.map(function (item) {
        return item.value;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var newTitle = ["{name|\u5408\u8BA1 ".concat(allNum, "}")].join('\n');
      this.option6.title.text = newTitle;
    },
    /**
             *
             * "todayUserNumber" => $rs->count() ?? 0, //今日新增用户
            "todayNewUserOrderCount" => $totalCount, //今日新增用户下单数
            "todayAmount" => $totalAmount, //今日新增用户下单总额
            处理用户相关
             **/
    handleOptions3: function handleOptions3(userNewInfo, _ref6) {
      var totalAmount = _ref6.totalAmount;
      // 删除this.config1.number中的元素，并且用userNewInfo.allUserNum替换
      console.log('用户总数', userNewInfo);
      var data = [];
      data.push({
        name: '新增用户数',
        value: userNewInfo.todayUserNumber,
        itemStyle: {
          color: this.echartsGraphic(['#0BFC7F', '#A3FDE0'])
        }
      });
      data.push({
        name: '新增下单数',
        value: userNewInfo.todayNewUserOrderCount,
        itemStyle: {
          color: this.echartsGraphic(['#F48C02', '#FDDB7D'])
        }
      });
      data.push({
        name: '新增下单总额',
        value: userNewInfo.todayAmount,
        itemStyle: {
          color: this.echartsGraphic(['#F4023C', '#FB6CB7'])
        }
      });
      var newTitle = ["{value|".concat(userNewInfo.allUserNum, "}"), '{name|总用户数}'].join('\n');
      this.option3.title.text = newTitle;
      this.option3.series[0].data = data;
      return;
      this.config1 = Object.assign({}, this.config1, {
        number: [userNewInfo.allUserNum],
        content: '总用户数:{nt}个'
      });
      this.config2 = Object.assign({}, this.config2, {
        number: [Number(totalAmount)],
        content: '收入总额:{nt}元'
      });
    },
    jumpPage: function jumpPage(val) {
      // data: ['车辆库存', '租用中', '已归还', '已购买'],
      console.log('jumpPage', val);
      var routes = [{
        dataIndex: 0,
        path: '/inOutBound/in'
      }, {
        dataIndex: 1,
        path: '/inOutBound/out'
      }, {
        dataIndex: 2,
        path: '/inOutBound/out'
      }, {
        dataIndex: 3,
        path: '/inOutBound/out'
      }];
      var dataIndex = val.dataIndex;
      var route = routes.find(function (item) {
        return item.dataIndex === dataIndex;
      });
      if (route) {
        this.$router.push({
          path: route.path,
          query: {
            dataIndex: dataIndex
          }
        });
      } else {
        console.error('未找到对应的路由路径');
      }
    }
  }
};
exports.default = _default;